<template lang="pug">
.homepage
  Start
  Box.homepage__rating
    RatingGlow.homepage__rating-glow
    Rating.homepage__rating-section
  EasyToUse
  Distribution
  Monetization
  Analytics
  MoveYourPodcast(:title="$t('pages.ssr_landing.move_your_podcast.title')" :description="$t('pages.ssr_landing.move_your_podcast.description')")
</template>

<script>
import getMeta from '@/lib/meta'
import alternateLinks from '@/lib/alternate-links'
import { schemaMarkup } from '@/lib/reviews/schema-markup'
import RatingGlow from '@/components/pages/landing/rating/svg/Glow.vue'
import Start from '@/components/pages/landing/start'
import Rating from '@/components/pages/landing/rating'
import EasyToUse from '@/components/pages/landing/easy-to-use'
import Distribution from '@/components/pages/landing/distribution'
import Monetization from '@/components/pages/landing/monetization'
import Analytics from '@/components/pages/landing/analytics'
import MoveYourPodcast from '@/components/pages/features/common/move-your-podcast'
import Box from '@/components/common/Box/Box'

export default {
  components: {
    Start,
    RatingGlow,
    Rating,
    EasyToUse,
    Distribution,
    Monetization,
    Analytics,
    MoveYourPodcast,
    Box
  },

  layout: 'landing',

  middleware: ['languageRedirect'],

  head () {
    const resultMeta = getMeta({
      title: this.$t('meta.homepage.title'),
      metaTitle: this.$t('meta.homepage.metaTitle'),
      description: this.$t('meta.homepage.description'),
      route: this.$route,
      i18nLocales: this.$i18n.locales,
      i18nSeo: this.$nuxtI18nSeo(),
      alternateLinks: alternateLinks.map(el => ({ title: this.$t(el.titleKey), href: el.href })),
      options: {
        gdpr: this.$store.state.auth.gdprThirdParty
      }
    })

    resultMeta.script.push({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schemaMarkup)
    })

    return resultMeta
  },

  mounted () {
    const hash = this.$route.hash

    if (hash) {
      location.hash = ''
      location.hash = hash
    }
  }
}
</script>

<style lang="scss">
@import './../components/pages/landing/index.scss';
</style>

<style lang="scss" scoped>
.homepage {
  overflow-x: clip;
  background: #1c0c32;
  padding-bottom: 155px;

  &__rating {
    position: relative;
    &-glow {
      z-index: 1;
      position: absolute;
      width: 787px;
      height: 482px;
      top: 50px;
      left: 25%;
      transform: translate(-50%, -50%);
      pointer-events: none;
    }

    &-section {
      position: relative;
      z-index: 0;
    }
  }
}
</style>
